import React from 'react';
import styles from './styles.module.css';
import { brand } from '@/commonTypes';
import AppLink from '@/components/common/AppLink';
import MainIcons from '@/icons/main';
import { brandBg } from '@/functions/formats';
import BrandLogo from './Brandlogo';

export default function BrandCard({
  item,
  index,
  className = '',
  homePage = false,
}: {
  item: brand;
  index: number;
  className?: string;
  homePage?: boolean;
}) {
  return (
    <AppLink
      href={`/brands/${item?.slug}`}
      className={`card movingCrad ${styles.card} ${homePage && styles.homeCard} ${className}`}
    >
      <div className={styles.header}>
        <BrandLogo name={item?.brand} index={index} image={item?.image} />

        {!homePage && <span className={`${styles.arrow} rotateIcon-rtl`}>‹</span>}
      </div>

      <h3 className={styles.title}>{item?.brand}</h3>

      {!homePage && (
        <div className={styles.country}>
          <MainIcons.GlobeIcon width={'13px'} height={'13px'} />
          <span>{item?.country?.title}</span>
        </div>
      )}

      {!homePage && (
        <div className={styles.footer}>
          <span className={styles.models}>
            <MainIcons.carIcon width={'13px'} height={'13px'} />
            <span>{item?.modelsCount} مدل</span>
          </span>
        </div>
      )}
    </AppLink>
  );
}
